var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcMeasurements(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.96 6C18.6218 6 19.2772 6.12963 19.8887 6.38086C20.5 6.63202 21.0555 6.99983 21.5234 7.46387C21.9914 7.92803 22.3629 8.47949 22.6162 9.08594C22.8694 9.69239 23 10.3426 23 10.999C23 11.5621 22.9029 12.1202 22.7158 12.6504C21.9002 12.2355 20.9778 12 20 12C16.6863 12 14 14.6863 14 18C14 19.1448 14.3206 20.2148 14.877 21.125L13.998 21.998L14 22L6.47656 14.5342C5.53141 13.5966 5 12.3249 5 10.999C5.00004 10.3426 5.13055 9.69239 5.38379 9.08594C5.63706 8.47949 6.00864 7.92803 6.47656 7.46387C6.94447 6.99983 7.50005 6.63202 8.11133 6.38086C8.72278 6.12963 9.37821 6 10.04 6C11.8719 6.00006 13.3627 6.83506 14 8.5C14.4108 7.42679 14.9136 6.84017 16.0312 6.38086C16.6426 6.12965 17.2982 6.00003 17.96 6ZM20 14C22.2091 14 24 15.7909 24 18C24 20.2091 22.2091 22 20 22C17.7909 22 16 20.2091 16 18C16 15.7909 17.7909 14 20 14ZM18.3535 15.6465C18.1583 15.4512 17.8417 15.4512 17.6465 15.6465C17.4512 15.8417 17.4512 16.1583 17.6465 16.3535L19.0342 17.7412C19.0121 17.8238 19 17.9105 19 18C19 18.5523 19.4477 19 20 19C20.5523 19 21 18.5523 21 18C21 17.4477 20.5523 17 20 17C19.9105 17 19.8238 17.0121 19.7412 17.0342L18.3535 15.6465Z",
    fill: "url(#paint0_linear_10289_502848)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_10289_502848",
    x1: 14.5,
    y1: 6.68571,
    x2: 14.5,
    y2: 21.3143,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D0D0D0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMeasurements);
export default __webpack_public_path__ + "static/media/ic-measurements.2a4a71e77f25fdde18dbff1c3b1ec556.svg";
export { ForwardRef as ReactComponent };